// de_pms_revenue.ts
// Tłumaczenia dla PMS.Revenue.tsx

export const dePmsRevenue = {

  title: "Revenue Management",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    forecast:          "Prognose und Erkenntnisse",
    demandCalendar:    "Nachfragekalender",
    activeRestrictions:"Aktive Restriktionen",
    eventsImpact:      "Veranstaltungseinfluss",
    conflictEngine:    "Konflikt-Engine",
    governance:        "Governance",
    derivedRules:      "Abgeleitete Regeln",
    groupsBlocks:      "Gruppen und Sperren",
  },

  // ── Etykiety KPI / tabeli ─────────────────────────────────────────────────
  labels: {
    adrGap:           "ADR-Luecke",
    cancellationRate: "Stornierungsrate",
    corporatePickup:  "Corporate Pickup",
    behindPace:       "Zurueck",
    onPace:           "Im Tempo",
    base:             "Basis",
    active:           "Aktiv",
    corporate:        "Corporate",
    event:            "Veranstaltung",
    forecast:         "Prognoza",
    critical:         "Kritisch",
  },

} as const;

export default dePmsRevenue;
